var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/slider/index.jsx",
    _this = this;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import ReactSlider from 'react-slider';
import PropTypes from 'prop-types';
var StyledSlider = styled(ReactSlider).withConfig({
  displayName: "slider__StyledSlider",
  componentId: "sc-rgjf3w-0"
})(["width:100%;height:20px;max-width:650px;"]);
var StyledThumb = styled.div.withConfig({
  displayName: "slider__StyledThumb",
  componentId: "sc-rgjf3w-1"
})(["height:20px;line-height:25px;width:20px;text-align:center;background-color:#000;color:#fff;border-radius:50%;cursor:grab;outline:none;&:focus{box-shadow:rgb(255 255 255) 0px 0px 0px 1px,rgb(166 229 255) 0px 0px 2px 3px,rgb(0 106 255) 0px 0px 2px 4px;}div.upper-tooltip{background:#2a2a33;border-radius:5px;color:#fff;font-size:12px;left:-30px;padding:0 15px;position:absolute;top:-35px;&:after{content:'';border-top:8px solid #2a2a33;border-left:8px solid transparent;border-right:8px solid transparent;margin-bottom:-8px;position:absolute;top:21px;left:34px;}}div.lower-tooltip{background:#fff;color:#2a2a33;top:30px;position:absolute;left:-24px;p{margin:auto;width:max-content;&.income-percentage-label{font-size:10px;}}}"]);

var Thumb = function Thumb(_ref) {
  var props = _ref.props,
      state = _ref.state,
      income = _ref.income;
  return /*#__PURE__*/React.createElement(StyledThumb, _extends({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "upper-tooltip",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, "$" + (Number.isNaN(state.value) ? 0 : state.value) + "/mo"), income && /*#__PURE__*/React.createElement("div", {
    className: "lower-tooltip",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 17
    }
  }, (income.monthlyNetIncomePretax === 0 ? 0 : Math.round(state.value / income.monthlyNetIncomePretax * 100)) + "%"), /*#__PURE__*/React.createElement("p", {
    className: "income-percentage-label",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 17
    }
  }, "of gross income")));
};

Thumb.propTypes = process.env.NODE_ENV !== "production" ? {
  props: PropTypes.shape({}).isRequired,
  state: PropTypes.shape({
    value: PropTypes.number
  }).isRequired,
  income: PropTypes.shape({
    monthlyNetIncomePretax: PropTypes.number
  }).isRequired
} : {};
var StyledTrack = styled.div.withConfig({
  displayName: "slider__StyledTrack",
  componentId: "sc-rgjf3w-2"
})(["top:0;bottom:0;background:", ";border-radius:999px;"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.index) === 0 ? '#006AFF' : '#D1D1D5';
});
var RedStyledTrack = styled(StyledTrack).withConfig({
  displayName: "slider__RedStyledTrack",
  componentId: "sc-rgjf3w-3"
})(["background:", ";"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.index) === 0 ? '#FF5A50' : '#D1D1D5';
});
var OrangeStyledTrack = styled(StyledTrack).withConfig({
  displayName: "slider__OrangeStyledTrack",
  componentId: "sc-rgjf3w-4"
})(["background:", ";"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.index) === 0 ? '#E96E2F' : '#D1D1D5';
});
var GreenStyledTrack = styled(StyledTrack).withConfig({
  displayName: "slider__GreenStyledTrack",
  componentId: "sc-rgjf3w-5"
})(["background:", ";"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.index) === 0 ? '#17B036' : '#D1D1D5';
});

var Track = function Track(_ref2) {
  var props = _ref2.props,
      state = _ref2.state,
      income = _ref2.income;
  var slider = /*#__PURE__*/React.createElement(StyledTrack, _extends({
    key: "blue-track"
  }, props, {
    index: state.index,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 18
    }
  }));

  if (income && income.monthlyNetIncome >= 0) {
    var debtIncomeRatio = state.value / income.monthlyNetIncomePretax;

    if (debtIncomeRatio <= 0.335) {
      slider = /*#__PURE__*/React.createElement(GreenStyledTrack, _extends({
        key: "green-track"
      }, props, {
        index: state.index,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116,
          columnNumber: 22
        }
      }));
    }

    if (debtIncomeRatio > 0.335) {
      slider = /*#__PURE__*/React.createElement(OrangeStyledTrack, _extends({
        key: "orange-track"
      }, props, {
        index: state.index,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 22
        }
      }));
    }

    if (income.monthlyNetIncome - state.value - income.monthlyDebtsAndExpenses < 0) {
      slider = /*#__PURE__*/React.createElement(RedStyledTrack, _extends({
        key: "red-track"
      }, props, {
        index: state.index,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 22
        }
      }));
    }
  }

  return slider;
};

var Slider = function Slider(_ref3) {
  var id = _ref3.id,
      className = _ref3.className,
      min = _ref3.min,
      max = _ref3.max,
      step = _ref3.step,
      value = _ref3.value,
      incomeAndDebt = _ref3.incomeAndDebt,
      _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(StyledSlider, {
    id: id,
    className: className,
    min: min,
    max: max,
    defaultValue: value,
    value: value,
    renderTrack: function renderTrack(props, state) {
      return /*#__PURE__*/React.createElement(Track, {
        props: props,
        state: state,
        income: incomeAndDebt,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 136,
          columnNumber: 40
        }
      });
    },
    renderThumb: function renderThumb(props, state) {
      return /*#__PURE__*/React.createElement(Thumb, {
        props: props,
        state: state,
        income: incomeAndDebt,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 40
        }
      });
    },
    step: step,
    onChange: function onChange(e) {
      return _onChange(e);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 5
    }
  });
};

Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  incomeAndDebt: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
} : {};
export default Slider;